import { render, staticRenderFns } from "./CampaignsReport.vue?vue&type=template&id=1f5020b6&scoped=true&lang=pug"
import script from "./CampaignsReport.js?vue&type=script&lang=js&external"
export * from "./CampaignsReport.js?vue&type=script&lang=js&external"
import style0 from "./CampaignsReport.vue?vue&type=style&index=0&id=1f5020b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5020b6",
  null
  
)

export default component.exports